import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useDisconnectMixpanel(
  tenant: number,
  options: UseMutationOptions = {}
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await axios.delete(`${getBongoUrl()}/v1/org/${tenant}/integrations/mixpanel`);
    },
    onSuccess: (...args) => {
      queryClient.setQueryData(['mixpanel', tenant], false);
      queryClient.invalidateQueries(['mixpanel-credentials', tenant]);
      options?.onSuccess?.(...args);
    },
  });
}
